import React, { useState } from 'react';
import './ProductDetailsDesignProposals.scss';

const PROPOSALS = [
  { id: 'a', name: 'Quick wins', desc: 'Dynamic discount, "View all reviews" link, quantity selector.', design: 'default' },
  { id: 'b', name: '+ Product info', desc: 'Accordions: Description, Material & care, Size guide.', design: 'default' },
  { id: 'c', name: '+ Colour & discovery', desc: 'SELECT COLOUR swatches, "More from brand" strip.', design: 'default' },
  { id: 'd', name: 'Minimal', desc: 'Generous whitespace, light borders, airy layout.', design: 'minimal' },
  { id: 'e', name: 'Card-based', desc: 'Each block in its own card with soft shadow.', design: 'cards' },
  { id: 'f', name: 'Bold headings', desc: 'Large section titles, compact content below.', design: 'bold' },
  { id: 'g', name: 'Compact', desc: 'Tighter spacing, smaller gaps, dense info.', design: 'compact' },
  { id: 'h', name: 'Left accent', desc: 'Coloured left border on each section.', design: 'accent' },
  { id: 'i', name: 'Rounded blocks', desc: 'Strong radius, soft background tints per block.', design: 'rounded' },
  { id: 'j', name: 'Divider-heavy', desc: 'Thin horizontal dividers between sections, no boxes.', design: 'dividers' },
  { id: 'k', name: 'Floating labels', desc: 'Small labels above sections with extra spacing.', design: 'labels' },
  { id: 'l', name: 'Dark CTA', desc: 'Dark primary button, high-contrast actions.', design: 'dark-cta' },
  { id: 'm', name: 'Two-column', desc: 'Price + rating side by side; size + quantity inline.', design: 'two-col' },
];

function MockPriceBlock({ showDynamicDiscount = false, designVariant }) {
  const isTwoCol = designVariant === 'two-col';
  return (
    <div className={`pdp-proposal-block pdp-price-block ${isTwoCol ? 'pdp-price-block--two-col' : ''}`}>
      <div className="pdp-category">T-SHIRTS</div>
      <h1 className="pdp-name">Classic Black T-Shirt</h1>
      {!isTwoCol && (
      <div className="pdp-rating-row">
        <span className="pdp-rating-badge">3.7 ★★★</span>
        <span className="pdp-rating-count">(480 Ratings)</span>
        <a href="#reviews" className="pdp-view-reviews">View all 480 reviews</a>
      </div>
      )}
      <div className="pdp-price-row">
        <span className="pdp-price">₹599</span>
        <span className="pdp-mrp">MRP <s>₹799</s></span>
        <span className="pdp-discount">{showDynamicDiscount ? '(25% OFF)' : '(74% OFF)'}</span>
      </div>
      {isTwoCol && (
        <div className="pdp-rating-row pdp-rating-row--inline">
          <span className="pdp-rating-badge">3.7 ★</span>
          <span className="pdp-rating-count">(480)</span>
          <a href="#reviews" className="pdp-view-reviews">View all</a>
        </div>
      )}
    </div>
  );
}

function MockSizeBlock({ withQuantity = false, designVariant }) {
  const isTwoCol = designVariant === 'two-col';
  return (
    <div className={`pdp-proposal-block pdp-size-block ${isTwoCol ? 'pdp-size-block--inline' : ''}`}>
      <h4 className="pdp-section-label">SELECT SIZE</h4>
      <div className={`pdp-size-buttons ${isTwoCol ? 'pdp-size-buttons--inline' : ''}`}>
        {['S', 'M', 'L', 'XL'].map((s, i) => (
          <div key={s} className={`pdp-size-btn ${i === 2 ? 'selected' : ''} ${i === 3 ? 'low' : ''}`}>
            <span>{s}</span>
            {i === 2 && <span className="pdp-stock">8 left</span>}
            {i === 3 && <span className="pdp-stock">5 left</span>}
          </div>
        ))}
      </div>
      {withQuantity && (
        <div className={`pdp-quantity-row ${isTwoCol ? 'pdp-quantity-row--inline' : ''}`}>
          <span className="pdp-section-label">Quantity</span>
          <div className="pdp-qty-controls">
            <button type="button" className="pdp-qty-btn" disabled>−</button>
            <input type="text" className="pdp-qty-input" value="1" readOnly />
            <button type="button" className="pdp-qty-btn">+</button>
          </div>
          <span className="pdp-only-left">Only 5 left</span>
        </div>
      )}
    </div>
  );
}

function MockActionsBlock() {
  return (
    <div className="pdp-proposal-block pdp-actions-block">
      <button type="button" className="pdp-add-to-bag">ADD TO BAG</button>
      <button type="button" className="pdp-wishlist">♡ Wishlist</button>
    </div>
  );
}

function MockDeliveryBlock() {
  return (
    <div className="pdp-proposal-block pdp-delivery-block">
      <h5 className="pdp-delivery-title">Delivery Check</h5>
      <div className="pdp-pincode-row">
        <input type="text" placeholder="Enter pincode" value="560045" readOnly className="pdp-pincode-input" />
        <span className="pdp-change-btn">CHANGE</span>
      </div>
      <ul className="pdp-trust-list">
        <li>✓ Assured On Quality</li>
        <li>✓ Secure Payment Options</li>
      </ul>
    </div>
  );
}

function MockAccordionSection() {
  const [open, setOpen] = useState(null);
  const items = [
    { id: 'desc', title: 'Product Description', content: 'Oversized fit, 100% cotton. Relaxed silhouette with a bold graphic print on the back.' },
    { id: 'material', title: 'Material & Care', content: 'Machine wash cold. Do not bleach. Tumble dry low.' },
    { id: 'size', title: 'Size Guide', content: 'S: Chest 36", M: 38", L: 40", XL: 42". Length from shoulder: S 28", M 29", L 30", XL 31".' },
  ];
  return (
    <div className="pdp-proposal-block pdp-accordion-block">
      <h4 className="pdp-section-label">Product information</h4>
      {items.map(({ id, title, content }) => (
        <div key={id} className="pdp-accordion-item">
          <button type="button" className="pdp-accordion-head" onClick={() => setOpen(open === id ? null : id)}>
            {title}
            <span className="pdp-accordion-icon">{open === id ? '−' : '+'}</span>
          </button>
          {open === id && <div className="pdp-accordion-body">{content}</div>}
        </div>
      ))}
    </div>
  );
}

function MockColourBlock() {
  const colours = [
    { name: 'Black', hex: '#1a1a1a' },
    { name: 'White', hex: '#f5f5f5' },
    { name: 'Navy', hex: '#1e3a5f' },
    { name: 'Grey', hex: '#6b7280' },
  ];
  return (
    <div className="pdp-proposal-block pdp-colour-block">
      <h4 className="pdp-section-label">SELECT COLOUR</h4>
      <div className="pdp-colour-swatches">
        {colours.map((c, i) => (
          <div key={c.name} className={`pdp-swatch ${i === 0 ? 'selected' : ''}`} title={c.name} style={{ backgroundColor: c.hex }}>
            {i === 0 && <span className="pdp-swatch-check">✓</span>}
          </div>
        ))}
      </div>
    </div>
  );
}

function MockMoreFromBrand() {
  return (
    <div className="pdp-proposal-block pdp-more-block">
      <h4 className="pdp-section-label">More from BULLMER</h4>
      <div className="pdp-more-strip">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="pdp-more-card">
            <div className="pdp-more-img" />
            <div className="pdp-more-name">Product {i}</div>
            <div className="pdp-more-price">₹499</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function ProposalPreview({ proposalId, designVariant }) {
  const showExtra = proposalId === 'b' || proposalId === 'c';
  const showColourAndMore = proposalId === 'c';
  return (
    <div className={`pdp-preview pdp-preview--${designVariant || 'default'}`}>
      <MockPriceBlock showDynamicDiscount designVariant={designVariant} />
      {showColourAndMore && <MockColourBlock />}
      <MockSizeBlock withQuantity designVariant={designVariant} />
      <MockActionsBlock />
      <MockDeliveryBlock />
      {showExtra && <MockAccordionSection />}
      {showColourAndMore && <MockMoreFromBrand />}
    </div>
  );
}

export function ProductDetailsDesignProposals() {
  const [activeId, setActiveId] = useState('a');

  return (
    <div className="product-details-design-proposals-page">
      <header className="pdp-page-header">
        <h1>Product details page – design proposals</h1>
        <p>Analysis and suggested improvements for the product details (specific/:product_id) layout, content, and separation. Choose a proposal to see a static mock.</p>
        <nav className="pdp-nav" aria-label="Design proposal options">
          {PROPOSALS.map((p) => (
            <button
              key={p.id}
              type="button"
              className={`pdp-nav-btn ${activeId === p.id ? 'active' : ''}`}
              onClick={() => setActiveId(p.id)}
            >
              {p.id.toUpperCase()}. {p.name}
            </button>
          ))}
        </nav>
      </header>

      <section className="pdp-analysis">
        <h2>Summary of improvements</h2>
        <ul>
          <li><strong>Data:</strong> Dynamic discount % from price/MRP; breadcrumbs from API; title aligned with variant/image.</li>
          <li><strong>UX:</strong> Quantity selector (with stock cap and “Only X left”); “View all X reviews” link; optional colour/variant selection.</li>
          <li><strong>Content:</strong> Accordions for Description, Material & care, Size guide, Shipping & returns.</li>
          <li><strong>Visual:</strong> Clear block separation (identity, choice+action, delivery+trust, accordions, discovery); hover/active states; optional countdown for flash sale.</li>
        </ul>
        <p>Full write-up: <code>Specific/PRODUCT_DETAILS_ANALYSIS.md</code></p>
      </section>

      <section className="pdp-mock-section">
        <h2>Proposal: {PROPOSALS.find((p) => p.id === activeId)?.name}</h2>
        <p className="pdp-mock-desc">{PROPOSALS.find((p) => p.id === activeId)?.desc}</p>
        <div className="pdp-mock-wrap">
          <ProposalPreview
            proposalId={activeId}
            designVariant={PROPOSALS.find((p) => p.id === activeId)?.design || 'default'}
          />
        </div>
      </section>
    </div>
  );
}
